/**
 * Provides base functionality for other modals to extend.  This object
 * provides functions to show and hide the modal and functions to
 * create the modal DOM elements.
 *
 * Lifecycle
 * ---------
 * When the subclass is being created, it should call
 * _createModalElementsOnLoad to generate to modal DOM elements. The modal
 * will consist of two div elements, "model" and an inner "modalContent".
 *
 * After the modal elements are created on page load, "_createAdditionalContent"
 * will be called.  This provides a hook for subclasses to create their own
 * custom DOM elements.
 *
 * Each time the modal is being displayed, "_getContent" is called. This is
 * the hook for subclasses to put content into the "modalContainer" element.
 */
'use strict';

var BaseModal = function () {};

BaseModal.prototype = {
    $modal: null,
    modalId: 'mainModal',
    $modalBody: null,
    modalContentId: null,
    modalDisplayed: false,
    //A flag that indicates if we've already created the modal DOM elements
    _initialized: false,

    MODAL_CONTENT_CLASS: 'modalContent',
    MODAL_CLASS: 'mits_modal',

    className: null,

    /*
     Public Methods
     */
    activate: function () {
        this._activate();
    },

    deactivate: function () {
        this.close();
    },

    close: function () {
        this._setModalDisplayed(false);
    },

    //Useful when going from one modal straight to another
    closeModalWithoutEnablingPage: function () {
        if (this.modalDisplayed) {
            //Unless the modal is displayed, the this.modal may not be
            //initialized
            this.$modal.modal('hide');
            this.modalDisplayed = false;
        }
    },

    /**
     * This is intended for displaying error messages, which should just consist of text
     * @param content
     */
    updateModalContentText: function(content) {
        this.$modalContent.html('<div class="modal-body">' + content + '</div>');
    },

    toString: function () {
        return '[BaseModal]';
    },

    /*
     Protected Methods
     */
    _loadMarkupOnLoad: function () {
        jQuery(document).ready(this._initializeIfNot.bind(this), true);
    },

    _activate: function () {
        this._initializeIfNot();

        this._setModalDisplayed(true);
    },

    /** Shows/hides the modal and the overlay behind it. */
    _setModalDisplayed: function (display) {
        this._initializeIfNot();

        if (display && !this.modalDisplayed) {
            this.$modal.modal('show');

            this._getContent();
        } else if (!display && this.modalDisplayed) {
            this.$modal.modal('hide');
        }

        this.modalDisplayed = display;
    },

    _initializeIfNot: function() {
        if (!this._initialized) {
            this._createModalElements();
            this._initialized = true;
        }
    },

    _setSizeSmall: function() {
        var modalDialog = this.$modal.find('div.modal-dialog');
        modalDialog.addClass('modal-sm').removeClass('modal-lg');
    },

    _setSizeDefault: function() {
        var modalDialog = this.$modal.find('div.modal-dialog');
        modalDialog.removeClass('modal-sm').removeClass('modal-lg');
    },

    _setSizeLarge: function() {
        var modalDialog = this.$modal.find('div.modal-dialog');
        modalDialog.removeClass('modal-sm').addClass('modal-lg');
    },

    /**
     * Generates the necessary DOM elements for the modal and the overlay.
     * Because this modifies the DOM, it can't be called until after the page
     * has been fully loaded.
     */
    _createModalElements: function () {
        if (!this.$modal) {
            this.$modal = jQuery(
                '<div id="' + this.modalId + '" class="modal fade" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false">' +
                    '<div class="modal-dialog">' +
                        '<div class="modal-content">' +
                        '</div>' +
                    '</div>' +
                '</div>');
            this.$modal.addClass(this.MODAL_CLASS);
            this.$modal.appendTo(document.body);
            this.$modalContent = this.$modal.find('div.modal-content');
            this.$modalContent.addClass(this.MODAL_CONTENT_CLASS);
            if (this.modalContentId) {
                this.$modalContent.attr('id', this.modalContentId);
            }
            this._createAdditionalContent(this.$modalContent);
        }
    },

    //Hooks for sub-classes
    _getContent: function () {
    },
    _createAdditionalContent: function () {
    }
};

module.exports = BaseModal;


//////////////////
// WEBPACK FOOTER
// ./mits/Widgets/Modal/BaseModal.js
// module id = 7
// module chunks = 0